export const createTransformHandler =
  (mapObject: { [key: string]: string }) =>
  (value: string): string => {
    return mapObject[value];
  };
